import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { httpinstance,httpinstancefile } from "../../../axios/api"


export const get_all_subscription_list = createAsyncThunk('get_all_subscription_list', async (queryParams)=>{
    try{
        const url = `admin/subscription${queryParams}`
        const response = await httpinstance.get(url)
        return response
    }catch (err){
        return err.response
    }
})
export const delete_vehicle = createAsyncThunk('delete_vehicle', async (id)=>{
    try{
        const url = `vehicle-types/${id}`
        const response = await httpinstance.delete(url)
        return response
    }catch (err){
        return err.response
    }
})

const initialState = {
    data:{},
    loading:false,
}

const subscription_managementSlice = createSlice({
    name : 'subscription_management',
    initialState,
})
export default subscription_managementSlice.reducer